import { convertColorsToRgba } from '../utils/convertColorsToRgba';
import { convertToDarkerRgba } from '../utils/convertToDarkerRgba';
import { convertToDarkRgba } from '../utils/convertToDarkRgba';
import { convertToLighterRgba } from '../utils/convertToLighterRgba';
import { convertToLightRgba } from '../utils/convertToLightRgba';
export const getColors = ({ backgroundColor, header, headerLink, links, outlineMenu, primary, publicFooterBackgroundColor, publicFooterColor, } = {}) => {
    const defaultColorPrimary = '#4733FF';
    const toolbarBuilderWrapper = '#383838';
    return convertColorsToRgba({
        asphalt: '#050505',
        banana: '#f5ca55',
        black: '#2B2B2B',
        bodyBackgroundColor: (backgroundColor || '#f5f6f6'),
        builder: {
            components: {
                body: '#5855D7',
                column: '#34C759',
                section: '#5855D7',
                single: '#34C759',
                structure: '#5855D7',
            },
            toolbar: {
                itemHover: convertToLightRgba(toolbarBuilderWrapper),
                wrapper: toolbarBuilderWrapper,
            },
        },
        cloud: '#EBEEF4',
        dove: '#737373',
        dustyGray: '#999999',
        fire: '#FD4329',
        floralWhite: '#FBF9F9',
        fog: 'rgba(0, 0, 0, 0.6)',
        grass: '#118906',
        header: (header || '#323a45'),
        headerLink: (headerLink || '#fafafa'),
        horizon: '#CECECE',
        input: {
            borderColor: '#737373',
            color: '#050505',
            error: {
                color: '#FD4329',
            },
            focus: {
                borderColor: (primary || defaultColorPrimary),
            },
            placeholder: '#737373',
        },
        link: (links || defaultColorPrimary),
        mandarine: '#FE9526',
        outlineMenu: (outlineMenu || '#FD4329'),
        paleSky: '#6c757d',
        primary: (primary || defaultColorPrimary),
        primaryDark: convertToDarkRgba(primary || defaultColorPrimary),
        primaryDarker: convertToDarkerRgba(primary || defaultColorPrimary),
        primaryLighter: convertToLighterRgba(primary || defaultColorPrimary),
        publicFooterBackgroundColor: (publicFooterBackgroundColor ||
            '#323A45'),
        publicFooterColor: (publicFooterColor || '#FAFAFA'),
        smoke: 'rgba(206,206,206,0.15)',
        smokeDark: 'rgba(206,206,206,0.25)',
        snow: '#fafafa',
        white: '#ffffff',
    });
};
//# sourceMappingURL=getColors.js.map